import React from 'react';
import list_icon from './assets/list.svg';
import start_icon from './assets/start.svg';
import settings_icon from './assets/settings-icon.svg';
import back_icon from './assets/back.svg'; 
import './SideBar.css';
import logo from '../../OperationDashboards/SideBar/assets/FlightDeckLogo.png';
import { Link, useLocation } from 'react-router-dom';

export default function TopBar() {
    const active = {backgroundColor: '#6359E9'};
    const location = useLocation();
    const path = location.pathname;
    return (
        <div className="side-bar">
            <div className="side-bar--logo">
                <img src={logo} alt="logo" />
                <h1>Opt-out</h1>
            </div>
            <div className="side-bar--menu">
                <Link className="side-bar--menu-item" to="list" style={path.includes('list') ? active : {}}>
                    <img src={list_icon} alt="clients-icon" />
                    <p>List</p>
                </Link>
                <Link className="side-bar--menu-item" to="start" style={path.includes('/start') ? active : {}}>
                    <img src={start_icon} alt="check-icon" />
                    <p>Start</p>
                </Link>
                <Link className="side-bar--menu-item">
                    <img src={settings_icon} alt="settings-icon" />
                    <p>Settings</p>
                </Link>
                <Link className="side-bar--menu-item back" to='/services'>
                    <img src={back_icon} alt="settings-icon" />
                    <p>Back</p>
                </Link>
            </div>
        </div>
    );
}